import MonthEvent from './MonthEvent';

export default MonthEvent;
